export enum MessageSenderTypeEnum {
	EMAIL = 1,
	WHATSAPP = 2,
}
